import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import Dialog from '@components/Dialog';
import { AGE_VALIDATION_MODAL_CLICK } from '@shopDetails/HOCs/WithAgeValidation/constants';

import messages from './messages';

function AgeValidationModalIsOfAge({
  onAccept,
  onClose,
  open,
  message,
  intl: { formatMessage },
}) {
  const { BUTTON, LESS, OUTSIDE, CLOSED } = AGE_VALIDATION_MODAL_CLICK;

  const [status, setStatus] = useState('');

  const onAcceptModal = useCallback(() => {
    onAccept(status);
    setStatus('');
  }, [status, onAccept]);

  const onCloseModal = useCallback(
    (action, clickLocation) => {
      setStatus('');
      if (onClose) onClose(action, clickLocation);
    },
    [onClose],
  );

  return (
    <Dialog
      open={open}
      title={formatMessage(messages.title)}
      text={message}
      firstButtonText={formatMessage(messages.cancelButton)}
      secondButtonText={formatMessage(messages.acceptButton)}
      onFirstOptionClick={() => onCloseModal(LESS, BUTTON)}
      onSecondOptionClick={onAcceptModal}
      onClose={() => onCloseModal(CLOSED, OUTSIDE)}
      buttonsType="inline"
    />
  );
}

AgeValidationModalIsOfAge.propTypes = {
  onAccept: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  intl: intlShape,
  message: PropTypes.string,
};

export default injectIntl(AgeValidationModalIsOfAge);
